import { createFileRoute } from '@tanstack/react-router';
import { Hydrate } from '@tanstack/react-start';
import { idle } from '@tanstack/react-start/hydration';
import { useMemo } from 'react';
import { NoteContent } from '#/components/notes/note-content.tsx';
import { extractHeadings } from '#/components/notes/table-of-contents.utils.ts';
import Backlog from './backlog.md?raw';

export const Route = createFileRoute('/admin/backlog')({
	component: RouteComponent,
	head: () => ({
		meta: [{ title: 'Article backlog - SohanScript' }],
	}),
});

function RouteComponent() {
	const headings = useMemo(() => extractHeadings(Backlog), []);

	return (
		<div className="pb-10">
			<section className="container min-w-0">
				<Hydrate when={idle()}>
					<NoteContent content={Backlog} headings={headings} />
				</Hydrate>
			</section>
		</div>
	);
}
